module.exports = __webpack_public_path__ + "img/logo_indogold2.e46d271a.png";